import { render, staticRenderFns } from "./Plants.vue?vue&type=template&id=2bad4a6a&scoped=true&"
import script from "./Plants.vue?vue&type=script&lang=ts&"
export * from "./Plants.vue?vue&type=script&lang=ts&"
import style0 from "./Plants.vue?vue&type=style&index=0&id=2bad4a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad4a6a",
  null
  
)

export default component.exports